import React from 'react'
import { Box, Text } from '@usap/uicomponents'
import { Heading2 } from '../../common/heading'

const ErrorMessageLb = () => (
  <Box
    fadeIn
    style={{
      padding: 16,
      width: '330px',
      backgroundColor: '#FFF',
    }}
  >
    <Heading2 style={{ fontSize: '20px' }} title="Error was encountered" />
    <Text size="small" margin={{ bottom: '20px' }}>
      Unable to process the request. Please try again later.
    </Text>
  </Box>
)

export default ErrorMessageLb
